"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const styles_1 = require("./styles");
const styling_1 = require("../../../styling");
const Close_1 = tslib_1.__importDefault(require("../../../ui-lib/Icons/Close"));
const context_1 = require("../../../context");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const Eye_1 = tslib_1.__importDefault(require("../../../ui-lib/Icons/Eye"));
const Camera_1 = tslib_1.__importDefault(require("../../../ui-lib/Icons/Camera"));
const MultistreamCarouselSlide = (0, mobx_react_lite_1.observer)(({ publicKey, classes, isMobile }) => {
    var _a, _b;
    const [isImageError, setIsImageError] = (0, react_1.useState)(false);
    const mergedClasses = (0, styling_1.useStyles)({ target: classes !== null && classes !== void 0 ? classes : {}, source: styles_1.carouselSlideStyles }, "multistream-carousel-slide");
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<MultistreamCarouselSlide/>");
    const { activePublicKeys, startPlayer, streams } = ctx;
    // Using a hash param to force reload of poster image
    const posterUrl = (0, react_1.useMemo)(() => { var _a; return `${(_a = streams[publicKey]) === null || _a === void 0 ? void 0 : _a.posterUrl}&hash=${Date.now()}`; }, [streams, publicKey]);
    const disconnected = (_a = streams[publicKey]) === null || _a === void 0 ? void 0 : _a.disconnected;
    const viewCount = (_b = streams[publicKey]) === null || _b === void 0 ? void 0 : _b.viewCount;
    const isStreamPlaying = activePublicKeys.includes(publicKey);
    (0, react_1.useEffect)(() => {
        let interval = null;
        if (isImageError) {
            interval = setInterval(() => {
                const img = new Image();
                img.onload = () => {
                    setIsImageError(false);
                    document.body.removeChild(img);
                    if (interval != null)
                        clearInterval(interval);
                };
                img.src = posterUrl !== null && posterUrl !== void 0 ? posterUrl : "";
                img.style.display = "none";
                document.body.appendChild(img);
            }, 2000);
        }
        return () => {
            if (interval)
                clearInterval(interval);
        };
    }, [isImageError, posterUrl]);
    if (disconnected) {
        return (react_1.default.createElement("div", { className: mergedClasses.disconnectedWrapper },
            react_1.default.createElement("h2", { className: mergedClasses.disconnected }, "OFFLINE")));
    }
    const shouldDisplayPosterImage = posterUrl != null && !isImageError;
    return (react_1.default.createElement("div", { className: shouldDisplayPosterImage ? mergedClasses.root : mergedClasses.disconnectedWrapper, onClick: () => isMobile && startPlayer(publicKey), onKeyDown: (e) => e.key === "Enter" && isMobile && startPlayer(publicKey), tabIndex: 0, role: "button", style: { cursor: isMobile ? "pointer" : "default" } },
        !isStreamPlaying === true && (react_1.default.createElement("button", { type: "button", onClick: () => startPlayer(publicKey), className: mergedClasses.addButton },
            react_1.default.createElement(Close_1.default, { weight: "normal", style: { width: "15px", transform: "rotateZ(45deg)", marginLeft: "3px" } }))),
        shouldDisplayPosterImage ? (react_1.default.createElement("img", { className: mergedClasses.image, src: posterUrl, alt: "video-poster", onError: () => setIsImageError(true) })) : (react_1.default.createElement("div", { className: mergedClasses.stockImageWrapper },
            react_1.default.createElement(Camera_1.default, { style: { width: "30%" }, outline: true }))),
        isStreamPlaying && react_1.default.createElement("div", { className: mergedClasses.playingOverlay }),
        viewCount != null && viewCount > 0 && (react_1.default.createElement("div", { className: mergedClasses.viewCount },
            react_1.default.createElement(Eye_1.default, { style: { width: "15px", marginRight: "3px", height: "11px" } }),
            react_1.default.createElement("span", null, viewCount)))));
});
exports.default = MultistreamCarouselSlide;
//# sourceMappingURL=MultistreamCarouselSlide.js.map